import styles from './styles.module.scss'
import { useEffect, useState } from 'react'
import { MdKeyboardDoubleArrowLeft } from 'react-icons/md'
import { MdKeyboardDoubleArrowRight } from 'react-icons/md'

export function PaginationNumber({
  total = 0,
  maxVisiblePages = 10,
  perPage = 25,
  page = 1,
  setPage,
  onPaging,
  infoPages = true,
  gotoPages = false,
}: any) {
  const [pages, setPages] = useState<any>([])
  const [totalPage, setTotalPage] = useState(0)

  const changePaging = (page: number) => {
    setPage(page)
    onPaging(page)
  }

  useEffect(() => {
    const totalPage = Math.ceil(total / perPage)
    let startPage = Math.max(1, page - Math.floor(maxVisiblePages / 2))

    if (startPage + maxVisiblePages - 1 > totalPage) {
      startPage = Math.max(1, totalPage - maxVisiblePages + 1)
    }

    const endPage = Math.min(startPage + maxVisiblePages - 1, totalPage)
    const pages = Array.from(
      { length: endPage - startPage + 1 },
      (_, index) => startPage + index
    )

    setPages(pages)
    setTotalPage(totalPage)
  }, [total, page])

  const gotoFirstPage = () => {
    setPage(1)
    onPaging(1)
  }

  const gotoLastPage = () => {
    setPage(totalPage)
    onPaging(totalPage)
  }

  return (
    <div className={styles.container}>
      <div className={styles.info}></div>
      <div className={styles.pages}>
        {gotoPages && page > 1 && (
          <MdKeyboardDoubleArrowLeft onClick={() => gotoFirstPage()} />
        )}
        <div className={styles.pageNumbers}>
          {pages.map((item: any, index: number) => (
            <a
              onClick={() => changePaging(item)}
              key={index}
              className={page == item ? styles.selected : ''}
            >
              {item}
            </a>
          ))}
        </div>
        {gotoPages && page !== totalPage && totalPage > 0 && (
          <MdKeyboardDoubleArrowRight onClick={() => gotoLastPage()} />
        )}
      </div>
      <div className={styles.infoPages}>
        {infoPages && (
          <>
            <span>
              Página {page} de {totalPage}
            </span>
            <small>{total} Iten(s)</small>
          </>
        )}
      </div>
    </div>
  )
}
